<template>
    <div class="tools-container">
        <div class="section-head">
            <span class="section-title">{{ dtitle }}</span>
            <span class="section-note">快捷入口</span>
        </div>

        <div class="icon-grid">
            <article class="icon-item" v-for="item in dataList" :key="item.id">
                <button type="button" class="icon-btn" @click="goDownload(item)">
                    <div class="pic"><img :src="item.pic" alt="" /></div>
                    <div class="title">{{ item.title }}</div>
                    <div class="download-text">下载</div>
                </button>
            </article>
        </div>
    </div>
</template>

<script>
export default {
    props: ["dataList", "dtitle"],
    methods: {
        goDownload(item) {
            if (!item || !item.url) return
            const popup = window.open(item.url, '_blank')
            if (!popup) {
                window.location.href = item.url
            }
            this.$http.post('/track_click', {
                target_type: 'app',
                target_id: item.id
            }).catch(() => {
                // 统计失败不阻断下载跳转
            })
        }
    }
};
</script>

<style lang="less" scoped>
.tools-container {
    border-radius: var(--a-radius);
}

.section-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: .6rem;
}

.section-title {
    color: #1a3260;
    font-size: 1.05rem;
    font-weight: 800;
}

.section-note {
    color: #00a49a;
    font-size: .8rem;
    font-weight: 700;
}

.icon-grid {
    display: flex;
    flex-wrap: wrap;
    gap: .12rem;
}

.icon-item {
    width: calc((100% - .6rem) / 6);
    flex: 0 0 calc((100% - .6rem) / 6);
    min-width: 0;
}

.icon-btn {
    width: 100%;
    border: 0;
    background: transparent;
    padding: 0;
    .pic {
        width: 100%;
        aspect-ratio: 1 / 1;
        max-height: 4.8rem;
        border-radius: .45rem;
        overflow: hidden;
        background: #edf6ff;
        border: 1px solid rgba(17, 109, 255, .14);
        box-shadow: 0 4px 10px rgba(17, 109, 255, .08);
        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            display: block;
        }
    }
}

.title {
    color: #1f3152;
    font-size: .76rem;
    font-weight: 700;
    line-height: 1.2;
    margin-top: .22rem;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.download-text {
    color: #116dff;
    font-size: .72rem;
    font-weight: 800;
    text-align: center;
    margin-top: .12rem;
    width: 100%;
    height: 1.2rem;
    line-height: 1.2rem;
    border: 1px solid rgba(17, 109, 255, .45);
    border-radius: .28rem;
    background: rgba(17, 109, 255, .06);
    box-sizing: border-box;
}

@media screen and (max-width: 360px) {
    .icon-item {
        width: calc((100% - .48rem) / 5);
        flex: 0 0 calc((100% - .48rem) / 5);
    }
}
</style>